<div class="section over-hide">
    <div class="section padding-top-120 padding-top-mob-nav section-background-rana">
        <div class="container-fluid padding-top-bottom-40 ">
            <div class="row justify-content-center">
                <div class="col-lg-7 col-xl-5">
                    <div class="section py-4 py-md-5 px-3 px-sm-4 px-lg-5 over-hide border-4 section-shadow-blue bg-whitesection-background-gradient-white-gray background-img-top form">

                        <form class="section text-center nfr-form-standard" [formGroup]="recoverForm" (ngSubmit)="onSubmit()">
                            <h4 class="mb-3">
                                Forgot your password
                            </h4>
                            <p class="mb-4">
                                Enter your username or email address and we will send you a link to reset your password.
                            </p>
                            <div class="form-group">
                                <input
                                        type="email"
                                        class="form-style big gray-version no-shadow section-shadow-blue"
                                        placeholder="Email"
                                        formControlName="email"
                                        autocomplete="off"

                                />
                                <div *ngIf="isSubmitted && email?.errors" class="invalid-feedback d-block text-left">
                                    <small *ngIf="email?.errors?.['required']">Email is required.</small>
                                    <small *ngIf="email?.errors?.['email']">Please enter a valid email address.</small>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-12 text-center">
                                    <button type="submit" class="btn btn-dark-primary" [disabled]="isLoading">
                                        Forgot password
                                        <i class="uil uil-arrow-right size-22 ml-3"></i>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
